module.exports = __webpack_public_path__ + "static/img/avatar.98321657.png";